export class AccountOperationReport {
    constructor() {
        this.AccountId = '';
        this.AccountName = '';
        this.InstrumentTradableID = 0;
        this.TradableInstrumentName = '';
        this.Date = 0;
        this.OperationTypeId = 0;
        this.OperationTypeName = '';
        this.OperationID = '';
        this.OpenPrice = '';
        this.ClosePrice = '';
        this.Amount = 0;
        this.CurrencyName = '';
        this.IsBuy = false;
        this.Quantity = 0;
        this.Instrument = null;
    }
    get IsTrading() {
        return this.OperationTypeId === 1;
    }
}
